import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { chakra, Text, VStack } from '@chakra-ui/react';
import { colors } from '../../../App/ChakraTheme';

import { NavigationSidebarContainer } from './NavigationSidebarContainer';
import { AuthContext, Role } from '../../../context/AuthProvider';
import { DashboardPage } from '../../app';
import { SignInPage, SignOutPage } from '../../auth';
import { useShowSettings } from '../../../hooks/useShowSettings';
import { useTranslation } from 'react-i18next';
import { Navigation } from '../../../components/Navigation';
import LanguagePicker from './LanguagePicker';
import i18n from '../../../i18n';

const MainSidebar: React.FC = () => {
  const user = useContext(AuthContext);
  const showSettings = useShowSettings();
  const signedIn = user?.is_authenticated;
  const isStudent = user?.roles?.includes(Role.student);
  console.log({ user });
  const isOrganizationUserOrHigher =
    user?.roles?.includes(Role.organization_user) ||
    user?.roles?.includes(Role.staff);
  const isTeacherOrHigher =
    user?.roles?.includes(Role.teacher) ||
    user?.roles?.includes(Role.manager) ||
    isOrganizationUserOrHigher;
  const showAnalyticsStaffPanel =
    isOrganizationUserOrHigher || user?.flags?.includes('extra-analytics');

  const { t } = useTranslation();

  function onLanguageChange(lng: any) {
    i18n.changeLanguage(lng);
  }

  return (
    <NavigationSidebarContainer
      user={user}
      className="col-cs dont-close-modal"
      style={{ width: '230px' }}
      spacing={0}
    >
      <VStack className="col-cs dont-close-modal" spacing={0} gap={2}>
        {signedIn ? (
          <>
            <chakra.hr className="navigation-links-separator dont-close-modal" />
            <VStack
              className="col-cs v-end dont-close-modal"
              style={{ flex: '3' }}
              spacing={0}
              gap={4}
            >
              <Link className="navigation-link" to={DashboardPage.getRoute()}>
                <Text as="h5" textStyle="h5">
                  {t('navigation.dashboard')}
                </Text>
              </Link>
              {!user.pending && (
                <a
                  className="navigation-link"
                  href={`https://editor.stemi.education?token=${user.token}`}
                >
                  <Text as="h5" textStyle="h5">
                    {t('navigation.editor')}
                  </Text>
                </a>
              )}
              {isTeacherOrHigher && (
                <Link className="navigation-link" to={'/licenses/'}>
                  <Text as="h5" textStyle="h5">
                    {t('navigation.manageClasses')}
                  </Text>
                </Link>
              )}
              {showAnalyticsStaffPanel && (
                <Link className="navigation-link" to={'/staffpanel/'}>
                  <Text as="h5" textStyle="h5">
                    {user.roles.includes(Role.staff)
                      ? t('navigation.staffPanel')
                      : t('navigation.analytics')}
                  </Text>
                </Link>
              )}
              {isStudent && !user.pending && (
                <Link className="navigation-link" to={'/profile'}>
                  <Text as="h5" textStyle="h5">
                    {t('navigation.profile')}
                  </Text>
                </Link>
              )}
              {showSettings && (
                <Link className="navigation-link" to={'/settings/'}>
                  <Text as="h5" textStyle="h5">
                    {t('navigation.settings')}
                  </Text>
                </Link>
              )}

              <Navigation.Item
                // className="hide-phone hide-tablet"
                variant={'right'}
                // style={{ marginRight: '48px' }}
              >
                <LanguagePicker
                  className="dont-close-modal"
                  onChange={onLanguageChange}
                  initialLanguage={i18n.language}
                />
              </Navigation.Item>
            </VStack>
          </>
        ) : null}

        <chakra.hr className="navigation-links-separator dont-close-modal" />
        <VStack
          style={{ flex: '4' }}
          className="col-cs dont-close-modal"
          spacing={0}
        >
          {signedIn ? (
            <Link
              className="navigation-link"
              to={SignOutPage.getRoute()}
              onClick={() => setTimeout(() => window.history.go(), 0)}
            >
              <Text
                as="h5"
                textStyle="h5"
                style={{ borderBottom: '1px solid ' + colors.darkblue }}
              >
                {t('navigation.signOut')}
              </Text>
            </Link>
          ) : (
            <Link to={SignInPage.getRoute()} className="navigation-link">
              <Text as="h5" textStyle="h5">
                {t('signInPage.signIn')}
              </Text>
            </Link>
          )}
        </VStack>
      </VStack>
    </NavigationSidebarContainer>
  );
};

export default MainSidebar;
